export default "__VITE_ASSET__CWjuzBun__"